import * as actionTypes from "./actionTypes";

export const getNotificationCount = () => {
  return {
    type: actionTypes.GET_NOTIFICATION_COUNT
  };
};

export const getNotificationCountSuccess = data => {
  return {
    type: actionTypes.GET_NOTIFICATION_COUNT_SUCCESS,
    data
  };
};

export const getNotificationCountFail = () => {
  return {
    type: actionTypes.GET_NOTIFICATION_COUNT_FAIL
  };
};

export const loadNotificationList = data => {
  return {
    type: actionTypes.LOAD_NOTIFICATION_LIST,
    data
  };
};

export const loadNotificationListSuccess = data => {
  return {
    type: actionTypes.LOAD_NOTIFICATION_LIST_SUCCESS,
    data
  };
};

export const loadNotificationListFail = () => {
  return {
    type: actionTypes.LOAD_NOTIFICATION_LIST_FAIL
  };
};

export const deleteNotification = (id, data) => {
  return {
    type: actionTypes.DELETE_NOTIFICATION,
    id,
    data
  };
};

export const deleteNotificationSuccess = () => {
  return {
    type: actionTypes.DELETE_NOTIFICATION_SUCCESS
  };
};

export const deleteNotificationFail = () => {
  return {
    type: actionTypes.DELETE_NOTIFICATION_FAIL
  };
};

export const markNotificationAsRead = (id, data) => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ,
    id,
    data
  };
};

export const markNotificationAsReadSuccess = () => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ_SUCCESS
  };
};

export const markNotificationAsReadFail = () => {
  return {
    type: actionTypes.MARK_NOTIFICATION_AS_READ_FAIL
  };
};
